import { LienPriorityType } from 'constants/loanApplication';
import { checkIsHelocLoanType } from 'utils/loanApplication';

const LoanPaymentField = {
  FIRST_LIEN: 'principalAndInterest',
  SUBORDINATE_LIEN: 'secondMortgagePrincipalAndInterest',
};

export const getPropertyAddressValue = ({ propertyAddressLine1, propertyAddressLine2 }) =>
  [propertyAddressLine1, propertyAddressLine2].filter(Boolean).join('\n');

export const getPropertyExpensesHoverData = (subjectPropertyData, isAdditionalLoan = false) => {
  const { loanTypeValue, qualifyingMonthlyPayment, piti, lienPriorityType } = subjectPropertyData;
  const isHeloc = checkIsHelocLoanType(loanTypeValue);

  if (!isHeloc || qualifyingMonthlyPayment == null) {
    return subjectPropertyData;
  }

  const isLoanPaymentSubordinate =
    !!isAdditionalLoan && lienPriorityType !== LienPriorityType.FIRST;
  const loanPaymentKey = isLoanPaymentSubordinate
    ? LoanPaymentField.SUBORDINATE_LIEN
    : LoanPaymentField.FIRST_LIEN;
  const currentLoanPayment = subjectPropertyData[loanPaymentKey] ?? 0;

  const adjustedPiti = piti == null ? piti : piti - currentLoanPayment + qualifyingMonthlyPayment;

  return {
    ...subjectPropertyData,
    [loanPaymentKey]: qualifyingMonthlyPayment,
    piti: adjustedPiti,
  };
};
